<template>
  <div class="filter-container">
    <div class="filter-container-header">
      <div class="filter-container-result">
        <div class="filter-container-result__title">
          Search results for "<span class="filter-container-result__keyword">{{ filter.keyword ?? categoryName }}</span>"
        </div>
      </div>
    </div>
  </div>
  <div class="filter-controls">
    <Filter
      v-model:sort="filter.sortMap"
      v-model:price-start="filter.priceStart"
      v-model:price-end="filter.priceEnd"
      @done="onReset"
    />
    <PriceTip class="filter-controls__tip" />
  </div>
</template>

<script setup>
import { buriedPointUtil, throttle } from '@/utils/utils'
import { useRoute } from 'vue-router'
import { useProductList } from '../../hooks/useProductList'
import { retrieveProductList } from '@/api/product'
import { Filter, PriceTip } from '@/components/Filter'

const route = useRoute()
const { filter, onReset } = useProductList()
const categoryName = computed(() => route.query.categoryName)

const categoryKeyword = ref('')

/**
 * 预请求列表接口，减少服务端从1688请求和处理数据所需的时间
 */
watch(categoryKeyword, throttle((keyword) => {
  retrieveProductList({
    ...filter,
    keyword,
    pageSize: 50,
    pageNow: 1,
    async: true
  })
}, 400))

watch(() => filter.sortMap, (val) => {
  if (val == null) {
    buriedPointUtil({
      eventId: 'PSF202',
      sortBy: 'Best Match',
      isDesc: 0
    })
  } else if (val.monthSold) {
    buriedPointUtil({
      eventId: 'PSF202',
      sortBy: 'Bestselling',
      isDesc: val.monthSold === 'desc' ? 1 : 0
    })
  } else if (val.price) {
    buriedPointUtil({
      eventId: 'PSF202',
      sortBy: 'price',
      isDesc: val.price === 'desc' ? 1 : 0
    })
  }
  onReset()
})
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
